var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',{ref:"gridOrigin",attrs:{"config":_vm.gridOriginConfig}},[_c('v-rect',{ref:"grid",attrs:{"config":_vm.gridRectConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }